import React from 'react';
import { AiFillFacebook } from "react-icons/ai";
import css from './icon.module.css'

export const facebookIcon = ({ ariaLabel = 'Facebook' }) => {
  return (
    <AiFillFacebook className={css.icon}/>
  );
};
